import React, { useCallback, useContext, useEffect, useState } from 'react';
import PageBanner from '../Usables/PageBanner';
import axios from 'axios';
import { basePath, currentDateAndTime, formatDate, getFriendlyDate, getGreeting } from '../Constants/constant';
import { AppContext } from '../ContextApi/ContextApi';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiSend, FiMail } from 'react-icons/fi';
import { HiOutlineCheckCircle } from 'react-icons/hi';
import { MdEventAvailable, MdDoneOutline, MdCancel, MdHighlightOff, MdPendingActions, MdUndo } from 'react-icons/md';
import { FaUserCheck, FaUserTie } from 'react-icons/fa';
import { LuListTodo } from "react-icons/lu";
import { IoAdd } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import TodoList from '../TodoList/TodoList';
import TodoForm from '../TodoList/TodoForm';
import NoRecords from '../Usables/NoRecords';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import RefreshButton from '../Usables/RefreshButton';
import Loader from "../Usables/Loader";
import InputField from '../Usables/InputField';
import BasicButton from '../Usables/Buttons';
import WorkAllowcation from './WorkAllowcation';


const DailyTask = () => {
    const { user, apiHeaderJSON } = useContext(AppContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [viewTodo, setViewTodo] = useState(false);
    const [viewTodoForm, setViewTodoForm] = useState(false);
    const [dashboardAccess, setDashboardAccess] = useState(false);
    const [todoList, setTodoList] = useState([]);
    const [atsIndex, setAtsIndex] = useState(false);
    const [loadingFilter , setloadingFilter] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [grouppedData, setGrouppedData] = useState([]);
    
    const [pagination, setPagination] = useState({
        page: 1,
        totalRecords: "",
        totalPages: "",
        limit: 10,
    });
    const [ischanged, setIschanged] = useState({
        getToDoChanged: false,
        getListChanged: false,
    });

    const [filterData, setFilterData] = useState({
        fromDate: "",
        toDate: "",
        taskStatus: "",
        recruiterId:""   
    });
    const [filter, setFilter] = useState({fromDate: "", toDate: "",});

    const toggleForm = () =>{
        setViewTodoForm(!viewTodoForm);
    }
    const getData = async()=> {
        try {
            const options = {
                params: {limit: pagination?.limit, page: pagination?.page, filter: JSON.stringify(filterData),},
                headers: apiHeaderJSON,
            };

            const [response1, response2] = await Promise.allSettled([
                axios.get(`${basePath}/getRecruiter`, { headers: apiHeaderJSON }),
                axios.get(`${basePath}/Tasks/GetAssignTasks`, options),
            ]);

            if (response1.status === "fulfilled") {
                const recruiterList = response1.value.data.map(val => ({value: val?.id, label: val?.name, activated: val?.activated}));
                const activeList = response1.value.data.filter(val => val?.activated === 1).map(val => ({value: val?.id, label: val?.name, activated: val?.activated}));
                setAllUsers(recruiterList);
                setUsersOption(activeList);
            } else {
                console.error("Recruiter API failed:", response1.reason);
            }

            if (response2.status === "fulfilled") {
                const { data } = response2.value;
                // console.log("response2.value", response2.value);
                setTodoList(data?.data);
                setGrouppedData(data?.groupped_data);
                setPagination(prev => ({...prev, totalPages: data?.pages, totalRecords: data?.totalRecords}));
            } else {
                console.error("Tasks API failed:", response2.reason);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Unexpected error:", error);
        }
    }

    // Function to set start and end of current month
   const currentMonthDates = () => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    console.log(formatDate(startOfMonth)); 
    console.log(formatDate(endOfMonth));   

    setFilter({
        fromDate: formatDate(startOfMonth),
        toDate: formatDate(endOfMonth),
    });
    setIschanged({ ...ischanged, getListChanged: true });
};

    useEffect(() => {
       if (ischanged?.getToDoChanged) {
        getTodoList();
        setIschanged({...ischanged, getToDoChanged: false});
    }
    }, [ischanged?.getToDoChanged]);


    const getTodoList = useCallback(async () => {
        try {
            const options = {
            params: {
                limit: pagination?.limit,
                page: pagination?.page,
                filter: JSON.stringify(filterData),
            },
            headers: apiHeaderJSON,
            };

            let response = await axios.get(`${basePath}/Tasks/GetAssignTasks`, options);

            if (response.status === 200 && response.data.success !== false) {
            setTodoList(response?.data?.data);
            setGrouppedData(response?.data?.groupped_data);
            setPagination(prev => ({
                ...prev,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            }));
            } else {
                toast.error(response?.data?.message || 'Something went wrong');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('getTodoList error ==>', error);
            toast.error('Network error! Please try again.');
        }
    }, [apiHeaderJSON, filterData, pagination]);

    useEffect(()=>{
        // console.log("apiHeaderJSON?.token 1",apiHeaderJSON?.token);
        if(!apiHeaderJSON?.token) return;
        setLoading("1");
        getData();
    },[apiHeaderJSON]);

    useEffect(()=>{
    let access = user?.filter((val, idx) => {
        if (val?.Module?.module_name === "ATS Pipeline") {
            setAtsIndex(idx);
            return val;
        }
    });
    // console.log("access====>>>>",access);
    setDashboardAccess(access);
    },[user]);
    const handleNavigate = ()=> {
        navigate("")
    }
    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getToDoChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getToDoChanged: true});
        }
    }
    const handleNext = (e)=> {
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getToDoChanged: true});
        }
    }
    const handleClose = (e)=> {
        setViewTodo(false);
        setFilterData({fromDate: "",
        toDate: "", taskStatus: "", recruiterId:"" });
        setPagination({page: 1, totalRecords: "", totalPages: "", limit: 10});
        setIschanged({...ischanged, getToDoChanged: true});
    };

    const handleChange = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilter({ ...filter, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceGetList();
    },[filter]);

    const handleExport = async () => {
        try {
            setloadingFilter(true);
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
                const response = await axios.get(`${basePath}/Tasks/GetAssignTasks`, {
                    params: {
                        filter: JSON.stringify(filterData),
                        download: 'Yes'
                    },
                    headers: apiHeaderJSON,
                    responseType: 'blob'  
                });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Task Report ${formatDate(currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            toast.success("Excel Exported Successfully!");
            setloadingFilter(false);
        } catch (error) {
            setloadingFilter(false);
            console.log('Error exporting jobs:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
            
        }
    };
    const handleTodo = (val) => {
        if (localStorage.getItem("role") === "Super Admin" || localStorage.getItem("role") === "Admin") {
            setFilterData({
                fromDate: val?.task_date,
                toDate: val?.task_date,
            });
            setIschanged({...ischanged, getToDoChanged: true});
            setViewTodo(true);
        }
        else {
            setViewTodo(true);
        }
    }

    const handleChangeFilter = useCallback((event)=> {
            const {name, value} = event?.target;
            // console.log("name, value", name, value);
            setFilterData({ ...filterData, [name]: value, });   
    },[filterData]);

    const handleClear = useCallback(()=> {
        // setLoadingFilter("2");
        setFilterData({
            fromDate: "",
            toDate: "",
            taskStatus: "",
            recruiterId:""    
        });
        setIschanged({...ischanged, getToDoChanged:true});
    },[ischanged]);

    const handleClearStatus = useCallback(()=> {
        setLoading("4");
        currentMonthDates();
    },[ischanged]);

    const handleFilter = useCallback(()=>{ 
        getTodoList();
    },[getTodoList]);

    const getUserData = async () => {
            let options = {
            headers:apiHeaderJSON
        }
        let response = await axios.get(`${basePath}/getRecruiter`, options);
        // console.log(response.data);
        const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        const listFilter = response?.data?.filter((val)=>{
            if(val?.activated === 1) return  val;
        });
        const activeList = listFilter?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        setAllUsers(recruiterList);
        setUsersOption(activeList);
    };

    const handleRefresh = useCallback(()=> {
        setLoading("2");
        getTodoList();
    },[getTodoList]);

    const todoProps = {
    todoList,
    pagination,
    getTodoList,
    handleLimit,
    handlePrev,
    handleNext,
    allUsers,
    handleClose,
    setUsersOption,
    handleChangeFilter,
    loadingFilter,
    handleClear,
    filterData,
    setFilterData,
    handleFilter,
    usersOption,
    handleExport
    };

    return (
        <>
            {(localStorage.getItem("role") === "Management") ? null :
                <div className='relative grayBlurShadow  bg-white rounded-lg overf low-hidden mt-4 max-h-[500px] overflow-auto'>
                    <div className=' flex items-center justify-between py-4 px-4 font-bold shadow-[0px_3px_10px_0px_#e2e8f0]'>
                        {/* <button className=' absolute top-1 left-4   flex items-center gap-1 text-blue-400'>View All <IoIosArrowRoundForward className=' text-blue-400' /></button> */}
                        <div onClick={handleTodo} className='flex items-center cursor-pointer hover:underline  justify-start gap-2 text-3xl '>
                            <LuListTodo className=' text-2xl text-gray-500 font-bold'/>
                            <h5>Daily Task</h5>
                        </div>
                        {viewTodoForm && <h2 className="text-xl font-semibold text-gray-800 mr-8">
                            Create New Task
                        </h2>}
                        {/* <div className='flex flex-col items-center justify-center'> */}
                            {/* <div className=' flex items-center gap-1 hover:text-blue-950 text-white rounded-lg p-2 border border-blue-950 bg-blue-950 shadow hover:bg-lime-200 transition duration-500 cursor-pointer ease-in-out'> */}
                                {viewTodoForm ? (
                                    <RxCross2
                                        onClick={toggleForm}
                                        className="text-4xl border border-red-500 hover:text-red-500 text-white rounded-lg p-2 bg-red-500 shadow hover:bg-red-200 transition duration-500 cursor-pointer ease-in-out"
                                    />
                                    ) : (
                                    <IoAdd
                                        onClick={toggleForm}
                                        className="text-4xl border border-blue-950 hover:text-blue-950 text-white rounded-lg p-2 bg-blue-950 shadow hover:bg-lime-200 transition duration-500 cursor-pointer ease-in-out"
                                    />
                                )}

                            {/* </div> */}
                        {/* </div> */}
                    </div>
                    {viewTodoForm ? 
                        <TodoForm  getTodoList = {getTodoList} /> :
                       <div className="flex flex-col space-y-3">
                        {(loading === "1" || loading === "2") ?
                            <Loader/> :
                            localStorage.getItem("role") === "Super Admin" || localStorage.getItem("role") === "Admin" ? 
                            <>
                            {(!grouppedData || grouppedData.length === 0) ? (
                                <NoRecords />
                            ) :
                            <div className=''>
                            <ul>
                                {grouppedData.map((val, idx) => (
                                <li key={idx} className="p-4 border-b hover:bg-gray-50 hover:drop-shadow transition duration-700 ease-in-out">
                                    <div className="flex justify-between items-center mb-1">
                                    {/* <h5 className="font-semibold text-lg text-gray-800">{val?.task_title}</h5> */}
                                    <h5 onClick={()=> handleTodo(val)} className={`font-semibold ${val?.task_date && getFriendlyDate(val.task_date) === "Today" ? 
                                    "text-green-700 bg-green-200 rounded-full px-2" : getFriendlyDate(val.task_date) === "Tomorrow" ? 
                                    "text-blue-800 bg-blue-200 rounded-full px-2" : "text-black" }  
                                    hover:underline cursor-pointer`}>{val?.task_date ? getFriendlyDate(val.task_date) : "N/A"}</h5>
                                    </div>
                                    <div>
                                        {Array.isArray(val?.tasks) && val?.tasks.slice(0, 4)?.map((item,idx)=> {
                                            return (
                                                <div className=' flex justify-between items-center mb-2'>
                                                    <p className="flex items-center justify-start gap-2 font-semibold text-left">
                                                        <p>{idx + 1}.</p>
                                                        <p className=" flex-1 line-clamp-1 font-semibold text-left">
                                                            {item?.task_description || "No description provided."}
                                                        </p>
                                                    </p>
                                                    <div className="flex items-center gap-2 text-sm">
                                                        {/* <span className="px-3 py-1 rounded-full text-nowrap bg-gray-100 text-gray-700 font-medium">
                                                            {item?.assigned_by || "N/A"}
                                                        </span>
                                                        <span className="text-gray-500">→</span> */}
                                                        <span className="px-3 py-1 rounded-full text-nowrap bg-blue-100 text-blue-700 font-medium">
                                                            {item?.assigned_to || "N/A"}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {val?.tasks?.length > 4 && 
                                        (<button onClick={()=> handleTodo(val)} className=' w-full text-left text-blue-500 hover:underline cursor-pointer' >More →</button>)}
                                    </div>
                                </li>
                                ))}
                            </ul>
                            </div>
                            }
                            <RefreshButton onClick={handleRefresh} position='absolute' className="bottom-1 right-2" />
                            </> :
                            (!todoList || todoList.length === 0) ? (
                                <NoRecords />
                            ) : (() => {
                                const pendingTodos = todoList.filter(item => item.task_status === 0);
                                if (pendingTodos.length === 0) {
                                return  <div className="flex flex-col items-center justify-center p-6 text-center mt-10">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-12 h-12 text-green-500 mb-3"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                        </svg>
                                        <h3 className="text-lg font-semibold text-gray-700">All caught up!</h3>
                                        <p className="text-gray-500 text-sm mt-1">No pending todos for now.</p>
                                    </div>
                                }
                                return (
                                    <>
                                        <ul>
                                            {pendingTodos.slice(0, 4).map((val, idx) => (
                                            <li key={idx} onClick={() => handleTodo(val)}
                                            className="p-4 border-b hover:bg-gray-50 hover:drop-shadow transition duration-700 cursor-pointer ease-in-out">
                                                <div className="flex justify-between items-center mb-1">
                                                {/* <h5 className="font-semibold text-lg text-gray-800">{val?.task_title}</h5> */}
                                                <h5 onClick={()=> handleTodo(val)} className={`font-semibold ${val?.task_date && getFriendlyDate(val.task_date) === "Today" ? "text-green-700 bg-green-200 rounded-full px-2" : getFriendlyDate(val.task_date) === "Tomorrow" ? "text-blue-800 bg-blue-200 rounded-full px-2" :
                                                getFriendlyDate(val.task_date) === "Yesterday" ? "text-amber-500 bg-amber-200 rounded-full px-2" : "text-black" }  hover:underline cursor-pointer`}>{val?.task_date ? getFriendlyDate(val.task_date) : "N/A"}</h5>
                                                <h6 className={`${val?.priority_classes} font-semibold px-2 py-1 rounded-full `}>
                                                    {val?.priority_label}
                                                </h6>
                                                </div>
                                                <p className=" line-clamp-1 font-semibold text-left">
                                                {val?.task_description || "No description provided."}
                                                </p>
                                                {/* <div className="flex items-center gap-2">
                                                    <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-semibold">
                                                        {val?.assigned_by?.name || "N/A"}
                                                    </span>
                                                    <span className="text-gray-500">→</span>
                                                    <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                                                        {val?.assigned_to?.name || "N/A"}
                                                    </span>
                                                </div> */}
                                            </li>
                                            ))}
                                        </ul>
                                    </>
                                );
                            })()
                        }
                       </div>
                    }
                    <button onClick={handleTodo} className=' text-blue-500 hover:underline cursor-pointer py-2' >View All →</button>
                    <RefreshButton onClick={handleRefresh} position='absolute' className="bottom-1 right-2" />
                </div>
            }
            {viewTodo && <TodoList setViewTodo = {setViewTodo} {...todoProps}/> }
        </>
    );
}

export default DailyTask;


